import React, {useState} from 'react';

import * as S from './FaqsNew.styles';

const FaqsNew = ({heading, faqData, faqHeadingData, isFaqActive = false}) => {
  const [active, setActive] = useState(0);
  const [activeHeading, setActiveHeading] = useState(0);
  const [faqSectionActive, setFaqSectionActive] = useState(isFaqActive);

  const handleFaqs = idx => {
    setActive(active === idx ? null : idx);
  };

  const handleHeading = idx => {
    setActiveHeading(activeHeading === idx ? null : idx);
  };

  const faqSectionVisibleHandle = () => {
    setFaqSectionActive(faqSectionActive => !faqSectionActive);
  };

  return (
    <S.FaqsCont>
      <S.FaqsInner>
        {faqHeadingData.length > 0 &&
          faqHeadingData.map(({id, question, answerList}, index) => (
            <S.FaqsRow key={id}>
              <S.FaqsHeadingQuestion
                isActive={activeHeading === index}
                onClick={() => handleHeading(index)}
              >
                {/* <p className={id <= 3 ? 'heading' : ''}>{question}</p> */}
                <h3 className="heading">{question}</h3>
              </S.FaqsHeadingQuestion>
              {
                <S.FaqsList>
                  {answerList.map((item, index) => {
                    return (
                      <li className="marker" key={index} dangerouslySetInnerHTML={{__html: item}}>
                        {/* {item} */}
                      </li>
                    );
                  })}
                </S.FaqsList>
              }
            </S.FaqsRow>
          ))}
        {heading && (
          <S.headingDiv isActive={true}>
            <S.FaqsHeading>{heading}</S.FaqsHeading>
          </S.headingDiv>
        )}
        {faqData &&
          faqData.length > 0 &&
          faqData.map(({id, question, answerList}, index) => (
            <S.FaqsRow key={id}>
              <S.FaqsQuestion>
                <h4>{question}</h4>
              </S.FaqsQuestion>

              <S.FaqsList>
                {answerList.map((item, index) => {
                  return (
                    <li className="marker" key={index}>
                      {item}
                    </li>
                  );
                })}
              </S.FaqsList>
            </S.FaqsRow>
          ))}
      </S.FaqsInner>
    </S.FaqsCont>
  );
};

export default FaqsNew;
